import { createAction, props } from '@ngrx/store';
import { LocationModel } from '../../shared/models/location.model';

export const setCentralLocationSelectorItemSelect = createAction(
    '[Central Location Selector] Set Central Location Selector Item Select',
    props<{ selectedLocation: any }>()
);

export const setCentralLocationSelectorItemSelectAll = createAction(
    '[Central Location Selector] Set Central Location Selector Item Select All',
    props<{ selectedLocations: any[] }>()
);

export const setCentralLocationSelectorItemDeSelect = createAction(
    '[Central Location Selector] Set Central Location Selector Item De-Select',
    props<{ selectedLocation: any }>()
);

export const setCentralLocationSelectorItemDeSelectAll = createAction(
    '[Central Location Selector] Set Central Location Selector Item De-Select All'
);

export const centralLocationSelectorItemChanged = createAction(
    '[Central Location Selector] Central Location Selector Item Changed'
);

export const loadCentralLobbyLocationDataSuccess = createAction(
    '[Central Location Selector] Load Central Lobby Location Data Success',
    props<{ locationData: any[] }>()
);

export const loadCentralLobbyLocationDataError = createAction(
    '[Central Location Selector] Load Central Lobby Location Data Success',
    props<{ error: string }>()
);

export const loadAllLocations = createAction(
    '[Central Location Selector] Load All Central Locations'

);

export const updateLoadAllLocations = createAction(
    '[Central Location Selector] Update All Locations',
    props<{ locations: LocationModel[] }>()
);

